import React from "react";
import { match as Match } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { injectIntl, IntlShape } from "react-intl";
import { withOneColLayout } from "../../../utils";
import CenterForm from "../form";
import PageSubheader from "../../../components/PageSubheader";

interface Props {
  match: Match;
  intl: IntlShape;
  backURL: string;
}

const CenterCreate = (props: Props) => {
  const { intl, backURL } = props;

  return (
    <>
      <Helmet>
        <title>
          {intl.formatMessage({ id: "page.center.create.document.title" })}
        </title>
      </Helmet>

      <PageSubheader
        goBackEnabled
        goBackId="btn-back-center-create"
        goBackURL={backURL}
      />

      <CenterForm {...props} />
    </>
  );
};

export default withOneColLayout(injectIntl(CenterCreate));
